const DISPLAY_NAME_OVERRIDES: Record<string, string> = {
  "Raw Material Purchase": "Purchases",
};

export const getMenuDisplayLabel = (displayName: string): string => {
  if (!displayName) return "";
  return DISPLAY_NAME_OVERRIDES[displayName] || displayName;
};
